import type { RouteObject } from "react-router-dom";
import Home from '../pages/home/page';
import ContratEntretienPage from '../pages/contrat-entretien/page';
import DeshumidificateursPage from '../pages/deshumidificateurs/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/contrat-entretien",
    element: <ContratEntretienPage />,
  },
  {
    path: "/deshumidificateurs",
    element: <DeshumidificateursPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;